<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/teRH3/tc-custom/9780374721480.jpg?1737775932548" alt="This image is the cover for the book The High Road"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The High Road
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Love and tragedy converge in a seaside town in <i>The High Road</i>, a newly reissued novel from Edna O’Brien, the author of <i>Girl</i> and “one of the most celebrated writers in the English language” (NPR’s <i>Weekend Edition</i>)</b><br/><br/>This richly peopled, compellingly readable novel explores the many lives of women—as mystic, mother, daughter, and lover. There is Iris, with her “winsome wonsome” ways, no longer young; there is Charlotte, a troubled debutante who has fled from society; and there is the narrator, Anna, who feels that her emotional life has folded until she meets a young Spanish girl named Catalina.<br/><br/>Set in a seaside enclave on the Mediterranean coast, <i>The High Road</i> is a passionate account of lost love and the return to loving, where currents of regret and loneliness clash with a fiery instinct for survival.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edna O'Brien
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Picador
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?460cbc92